var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"logo",staticClass:"logo",staticStyle:{"flex":"auto","width":"auto"}},[_c('span',{staticStyle:{"color":"#FFF"}}),_c('h1',[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }